<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<template v-if="treeShow">
								<tree ref="tree0" :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
						<el-tab-pane :label="$t('label_161')" name="second">
							<template v-if="treeShow">
								<tree ref="tree1" :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="checkAllMes" v-if="getTreeMes=='0'">
						<div class="statusMesList">
							<div class="statusNumList">
								<p><span class="square" style="background: #0353c1"></span>
									<span class="text">{{$t('label_451')}}</span>
									<span class="num" style="color: #0353c1">{{checkCount.num}}</span></p>
								<p><span class="square" style="background: #3fb393"></span>
									<span class="text">{{$t('label_455')}}</span>
									<span class="num" style="color: #3fb393">{{checkCount.checkStatus2}}</span></p>
								<p><span class="square" style="background: #ffb400"></span>
									<span class="text">{{$t('label_459')}}</span>
									<span class="num" style="color: #ffb400">{{checkCount.checkStatus1}}</span></p>
								<p><span class="square" style="background: #fe0000"></span>
									<span class="text">{{$t('label_461')}}</span>
									<span class="num" style="color: #fe0000">{{checkCount.checkStatus3}}</span></p>
								<p><span class="square" style="background: #aeaeae"></span>
									<span class="text">{{$t('label_464')}}</span>
									<span class="num" style="color: #aeaeae">{{checkCount.checkStatus0}}</span></p>
							</div>
							<div class="numListPro">
								<div v-for="item in checkCount.checkStatus2" style="background: #3fb393"></div>
								<div v-for="item in checkCount.checkStatus1" style="background: #ffb400"></div>
								<div v-for="item in checkCount.checkStatus3" style="background: #fe0000"></div>
								<div v-for="item in checkCount.checkStatus0" style="background: #aeaeae"></div>
							</div>
						</div>
						<div class="tableList" style="top: 110px">
							<div class="tableNum">
								<p class="p1">{{checkCount.numInfoAll}}</p>
								<p class="p2">{{checkCount.numTypeCheckInfoAll}}</p>
							</div>
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="allTableData" highlight-current-row @current-change="handleCurrentChangeAll"
							 @row-dblclick="dbSelected" border style="width: 100%;margin-bottom: 10px;" height="calc(100% - 50px)"
							 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
								<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
								</el-table-column>
								<el-table-column prop="pname" :label="$t('label_429')" align="center">
                  <template slot-scope="scope">
                    {{scope.row.pname == '' ? scope.row.name : scope.row.pname}}
                  </template>
								</el-table-column>
								<el-table-column prop="name" :label="$t('label_39')" align="center">
								</el-table-column>
								<el-table-column prop="checkBeginTime" :label="$t('label_470')" align="center">
								</el-table-column>
								<el-table-column prop="checkEndTime" :label="$t('label_473')" align="center">
								</el-table-column>
								<el-table-column prop="checkStatus" :label="$t('label_475')" align="center">
									<template slot-scope="scope">
										<p :style="{'color':statusText[scope.row.checkStatus].color}" style="font-weight: bold">
											{{statusText[scope.row.checkStatus].text}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="eqnum" :label="$t('label_477')" align="center" width="200">
								</el-table-column>
								<el-table-column prop="num" :label="$t('label_736')" align="center" width="200">
								</el-table-column>
							</el-table>
							<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
							 @parentMethod="selectEquipmentCheckPageAll"></Page>
						</div>
					</div>

					<div class="treeMes" v-if="getTreeMes=='1'">
						<!-- <p class="title">
							<span class="spot">{{this.checkName}}</span>
						</p> -->
						<p class="title"><span class="spot">{{this.checkName}}</span>{{$t('label_740')}}</p>
						<div class="chooseBox">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_123')}}</p>
										</div>
										<div v-if="checkStatus=='3'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/stop.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('btn_37')}}</span>
										</div>
										<div v-else-if="checkStatus=='2'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/use.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('btn_36')}}</span>
										</div>
										<div v-else-if="checkStatus=='1'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/unUse.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('label_443')}}</span>
										</div>
										<div v-else class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/planBlack.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('label_447')}}</span>
										</div>
									</div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_481')}}</p>
										</div>
										<div v-if="checkStatusBtn==0">
											<el-date-picker style="width: 190px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="startORstopList.time"
											 :placeholder="$t('input_91')" :disabled="true"></el-date-picker>
										</div>
										<div v-if="checkStatusBtn==1">
											<el-date-picker style="width: 190px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="startORstopList.time"
											 :placeholder="$t('input_91')" :picker-options="pickerOptions"></el-date-picker>
										</div>

									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div v-if="checkStatusBtn==0">
									<div class="chooseButton2 searchButton" style="cursor: not-allowed;">{{$t('btn_36')}}</div>
									<div class="chooseButton2 deleteButton" @click="startORstop(1)">{{$t('btn_37')}}</div>
								</div>
								<div v-if="checkStatusBtn==1">
									<div class="chooseButton2 searchButton" @click="startORstop(0)">{{$t('btn_36')}}</div>
									<div class="chooseButton2 deleteButton" style="cursor: not-allowed;">{{$t('btn_37')}}</div>
								</div>
                <div class="chooseButton2 searchButton"
                     @click="resetHandle()">{{$t('btn_69')}}</div>
                <div class="chooseButton2 searchButton"
                     @click="notWorkHandle()">{{ $t('label_777') }}</div>
				<div class="chooseButton2 searchButton" @click="syncReginoalRest()">{{$t('btn_71')}}</div>
							</div>
						</div>
						<div class="spotMesBox gaobugou">
							<el-tabs v-model="activeNameDevice" @tab-click="handleClickDevice">
								<el-tab-pane :label="$t('label_1')" name="device" style="height: 100%;" v-if="MenuRoleList.indexOf('104')>=0">
									<div class="tableList" style="height: 100%; padding-top: 0;">
<!--										<div class="tableNum">-->
<!--											&lt;!&ndash; <p class="p1" style="width:180px">{{checkPlanCount.durationnum}}</p> &ndash;&gt;-->
<!--											<p class="p2" style="width: 150px">{{checkPlanCount.checknum}}</p>-->
<!--											<p style="width: 290px"></p>-->
<!--										</div>-->
<!--										<checkItemArea ref="checkItemAreaDisplay" :showButton="true" :needSort="true"></checkItemArea>-->

                    <checkItemArea ref="checkItemAreaDisplay" :showButton="true" :needSort="true">
                      <div class="tableNum">
                        <!-- <p class="p1" style="width:180px">{{checkPlanCount.durationnum}}</p> -->
                        <p class="p2" style="width: 150px">{{checkPlanCount.checknum}}</p>
                        <p style="width: 290px"></p>
                      </div>
                    </checkItemArea>
									</div>
								</el-tab-pane>
								<el-tab-pane :label="$t('label_147')" name="devicetime" style="height: 100%;" v-loading="saveLoading" v-if="MenuRoleList.indexOf('100')>=0">
									<div class="buttonBox">
										<div>
											<div class="chooseButton searchButton" @click="timeAdd" v-if="MenuRoleList.indexOf('38')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
											</div>
											<div class="chooseButton searchButton" @click="timeUpdate" v-if="MenuRoleList.indexOf('39')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
											</div>
											<div class="chooseButton deleteButton" @click="timeDelete" v-if="MenuRoleList.indexOf('40')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
											<div class="chooseButton searchButton" @click="timeBatch" v-if="MenuRoleList.indexOf('101')>=0"><i class="el-icon-finished"></i>{{$t('label_738')}}
											</div>
											<div class="chooseButton searchButton" v-loading="saveLoading" @click="timeAcquiescence" v-if="MenuRoleList.indexOf('417')>=0"><i class="el-icon-refresh"></i>{{$t('btn_25')}}
											</div>
										</div>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
									 border style="width: 100%;height:100%;margin: 10px 0px;" height="86%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndexTime" width="50">
										</el-table-column>
										<el-table-column prop="beginTime" :label="$t('label_580')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.beginTime}}
													<span v-if="scope.row.beginTimeOverDay==1">{{$t('label_151')}}</span>
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="endTime" :label="$t('label_585')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.endTime}}
													<span v-if="scope.row.endTimeOverDay==1">{{$t('label_151')}}</span>
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="duration" :label="$t('label_96') + '(' + $t('label_647') + ')'" align="center">
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModelTime" :total="pageCountTime" :display="pageSizeTime" :pagegroup="3"
									 :currentspage="1" @parentMethod="selectTime"></Page>
								</el-tab-pane>
								<el-tab-pane :label="$t('btn_59')" name="devicerest" style="height: 100%" v-if="MenuRoleList.indexOf('102')>=0">
									<calendar v-loading="saveLoading" ref="calendarDisplay" @saveRest="saveRest" @acquiescenceRest="acquiescenceRest" :showButton="MenuRoleList.indexOf('419') != -1"
									 :calendarData="calendarData" @selectRest="selectRest"></calendar>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>

					<div class="checkAllMes" v-if="getTreeMes=='2'">
						<div class="tableList" style="height: 100%;">
							<p class="title">{{$t('label_272')}}</p>
							<div class="tableNum" style="height: 42px;">
								<p class="p1" style="width:200px">{{checkPlanCount.num}}</p>
								<p class="p2" style="width:200px">{{checkPlanCount.checknum}}</p>
							</div>
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="allAreaData" highlight-current-row @current-change="handleCurrentChangeAll"
							 @row-dblclick="dbSelected" border style="width: 100%;margin-bottom: 10px;" height="calc(100% - 100px)"
							 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
								<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
								</el-table-column>
								<el-table-column prop="name" :label="$t('label_297')" align="center">
									<template slot-scope="scope">
										<!-- {{scope.row.dname}} {{scope.row.wname}}
										<br>
										{{scope.row.name}} -->
										{{scope.row.name}}
									</template>
								</el-table-column>
								<el-table-column prop="durationnum" :label="$t('label_739') + '(' + $t('label_647') + ')'" align="center">
								</el-table-column>
								<el-table-column prop="num" :label="$t('label_477')" align="center" width="200">
								</el-table-column>
								<el-table-column prop="checknum" :label="$t('label_736')" align="center" width="200">
								</el-table-column>
							</el-table>
							<Page class="item" ref="pageModelArea" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
							 @parentMethod="selectEquipmentAreaPageAll"></Page>
						</div>
					</div>

					<div class="treeMes" v-if="getTreeMes=='3'">
						<!-- <p class="title"><span class="spot">{{this.checkName}}</span></p> -->
						<p class="title"><span class="spot">{{this.checkName}}</span>{{$t('label_740')}}</p>
						<div class="chooseBox">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_123')}}</p>
										</div>
										<div v-if="checkStatus=='3'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/stop.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('btn_37')}}</span>
										</div>
										<div v-else-if="checkStatus=='2'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/use.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('btn_36')}}</span>
										</div>
										<div v-else-if="checkStatus=='1'" class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/unUse.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('label_443')}}</span>
										</div>
										<div v-else class="select" style="display: flex;align-items: center;font-size: 14px;">
											<img src="/static/img/spot/planBlack.png" class="statusSpan" style="margin: 10px;"><span class="statusSpan">{{$t('label_447')}}</span>
										</div>
									</div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_481')}}</p>
										</div>
										<div v-if="checkStatusBtn==0">
											<el-date-picker style="width: 210px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="startORstopList.time"
											 :placeholder="$t('input_91')" :disabled="true"></el-date-picker>
										</div>
										<div v-if="checkStatusBtn==1">
											<el-date-picker style="width: 210px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="startORstopList.time"
											 :placeholder="$t('input_91')" :picker-options="pickerOptions"></el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div v-if="checkStatusBtn==0">
									<div class="chooseButton2 searchButton" style="cursor: not-allowed;">{{$t('btn_36')}}</div>
									<div class="chooseButton2 deleteButton" @click="startORstop(1)">{{$t('btn_37')}}</div>
								</div>
								<div v-if="checkStatusBtn==1">
									<div class="chooseButton2 searchButton" @click="startORstop(0)">{{$t('btn_36')}}</div>
									<div class="chooseButton2 deleteButton" style="cursor: not-allowed;">{{$t('btn_37')}}</div>
								</div>
                <div class="chooseButton2 searchButton"
                     @click="resetHandle()">{{$t('btn_69')}}</div>
                <div class="chooseButton2 searchButton"
                     @click="notWorkHandle()">{{ $t('label_777') }}</div>
							</div>
						</div>
						<div class="spotMesBox gaobugou">
							<el-tabs v-model="activeNameDevice" @tab-click="handleClickDevice">
								<el-tab-pane :label="$t('label_533')" name="device" style="height: 650px;" v-if="MenuRoleList.indexOf('99')>=0">
									<template v-if="this.tableDataTreeBatchTimeEdit.type == '0'">
										<checkItem ref="checkItemDisplay" :showButton="false" :needSort="true"></checkItem>
									</template>
									<template v-if="this.tableDataTreeBatchTimeEdit.type == '1'">
										<checkItemParam ref="checkItemParamDisplay" :showButton="false" :needSort="true"></checkItemParam>
									</template>
								</el-tab-pane>
								<el-tab-pane :label="$t('label_147')" name="devicetime" style="height: 100%" v-loading="saveLoading" v-if="MenuRoleList.indexOf('100')>=0">
									<div class="buttonBox">
										<div>
											<div class="chooseButton searchButton" @click="timeAdd" v-if="MenuRoleList.indexOf('38')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
											</div>
											<div class="chooseButton searchButton" @click="timeUpdate" v-if="MenuRoleList.indexOf('39')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
											</div>
											<div class="chooseButton deleteButton" @click="timeDelete" v-if="MenuRoleList.indexOf('40')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
											<div class="chooseButton searchButton" @click="timeBatch" v-if="MenuRoleList.indexOf('101')>=0"><i class="el-icon-finished"></i>{{$t('label_738')}}
											</div>
											<div class="chooseButton searchButton"  @click="timeAcquiescence" v-if="MenuRoleList.indexOf('417')>=0"><i
												 class="el-icon-refresh"></i>{{$t('btn_25')}}
											</div>
										</div>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
									 border style="width: 100%;margin: 10px 0 10px 0;" height="calc(100% - 85px)" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndexTime" width="50">
										</el-table-column>
										<el-table-column prop="beginTime" :label="$t('label_580')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.beginTime}}
													<span v-if="scope.row.beginTimeOverDay==1">{{$t('label_151')}}</span>
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="endTime" :label="$t('label_585')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.endTime}}
													<span v-if="scope.row.endTimeOverDay==1">{{$t('label_151')}}</span>
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="duration" :label="$t('label_96') + '(' + $t('label_647') + ')'" align="center">
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModelTime" :total="pageCountTime" :display="pageSizeTime" :pagegroup="3"
									 :currentspage="1" @parentMethod="selectTime"></Page>
								</el-tab-pane>
								<el-tab-pane :label="$t('btn_59')" name="devicerest" style="height: 100%" v-if="MenuRoleList.indexOf('102')>=0">
									<!-- <calendar></calendar> -->
									<calendar v-loading="saveLoading" ref="calendarDisplay" @saveRest="saveRest" @acquiescenceRest="acquiescenceRest" :showButton="MenuRoleList.indexOf('419') != -1"
									 :calendarData="calendarData" @selectRest="selectRest"></calendar>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>

				</div>
			</div>
		</div>

		<el-dialog :title="$t('btn_15')" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false' width="800px" top="10%"
		 :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_533')}}</p>
						<div class="mesInput">
							<el-input v-model="tableDataTreeEdit.spotPro" disabled></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 100px">
						<p>{{$t('label_742')}}</p>
						<div class="mesInput">
							<el-select v-model="tableDataTreeEdit.spotFun" filterable :placeholder="$t('input_65')">
								<el-option v-for="item in spotFunOptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_212')}}</p>
					<div class="mesInput" style="width: 640px">
						<el-input type="textarea" :placeholder="$t('input_49')" maxlength="200" show-word-limit v-model="tableDataTreeEdit.spotProCon"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_741')}}</p>
					<div class="mesInput" style="display: flex;width: 640px">
						<el-radio v-model="tableDataTreeEdit.spotCycle" label="0">
							<el-input style="width: 60px" :value="$t('label_652')" disabled></el-input>
						</el-radio>
						<el-radio v-model="tableDataTreeEdit.spotCycle" label="1">
							<el-select v-model="tableDataTreeEdit.weekend" style="width: 100px" filterable :placeholder="$t('input_65')">
								<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-radio>
						<el-radio v-model="tableDataTreeEdit.spotCycle" label="2">
							<el-select style="width: 90px" v-model="tableDataTreeEdit.month" filterable :placeholder="$t('input_65')" @change="changeSelectMonth">
								<el-option v-for="(item,index) in monthOptions" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
							<el-select style="width: 90px" v-model="tableDataTreeEdit.monthD" :placeholder="$t('input_65')">
								<el-option v-for="(item,index) in monthDOptions" :key="index" :label="item" :value="item" />
							</el-select>
						</el-radio>
						<el-radio v-model="tableDataTreeEdit.spotCycle" label="3">{{$t('label_531')}}
							<el-input v-model="tableDataTreeEdit.monthDMes" style="width: 60px"></el-input>
							{{$t('label_537')}}
						</el-radio>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_847')}}</p>
					<div class="mesInput" style="display: flex;width: 640px;padding-top: 13px">
						<el-radio label="0" v-model="tableDataTreeEdit.selectOption">{{$t('label_145')}}</el-radio>
						<el-radio label="1" v-model="tableDataTreeEdit.selectOption">{{$t('label_149')}}</el-radio>
						<el-radio label="2" v-model="tableDataTreeEdit.selectOption">{{$t('label_141')}}</el-radio>
					</div>
				</div>
				<div class="dialogMes">
					<p></p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;padding-top: 13px;padding-left:15px">
								<p style="width: 170px">{{$t('label_849')}}</p>
								<p style="width: 160px">{{$t('label_928')}}</p>
								<p style="width: 160px">{{$t('btn_25')}}</p>
							</div>
							<div class="select" style="display: flex;">
								<div class="selectMes" style="width: 450px;border:1px solid #dedede;padding: 10px;height: 160px;overflow:auto;">
									<div class="mes" style="display: flex;margin-bottom: 10px" v-for="item in 2">
										<el-input style="width: 150px"></el-input>
										<el-select style="width: 150px;margin-left:20px"></el-select>
										<div class="choose" style="padding-top: 13px;margin-left: 20px"><i class="el-icon-success" style="color: #43C477;font-size: 20px"></i>
										</div>
										<div class="del" style="padding-top: 13px;margin-left: 20px"><i class="el-icon-remove" style="color: #ff3300;font-size: 20px"></i>
										</div>
									</div>
									<div class="add" style="width: 30px">
										<i class="el-icon-circle-plus" style="font-size: 22px;color:#0353c1 "></i>
									</div>
								</div>
								<div class="photoStyle" style="display: flex;justify-content: center;width: 100px;flex-wrap: wrap;text-align: center">
									<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px">
										<i class="el-icon-camera" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_806')}}</p>
									<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px">
										<i class="el-icon-video-camera" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_863')}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p v-if="$store.getters.getVersions == 2" style="width: 100px;line-height: 25px">{{$t('label_555')}}(E-SOP)</p>
          <p v-else style="width: 100px;line-height: 25px">{{$t('label_555')}}</p>
					<div class="mesInput">
						<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px">
							<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_14')" :visible.sync="dialogSpotTimeAdd" append-to-body :close-on-click-modal='false' width="450px"
		 top="15%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p>{{$t('label_580')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.beginTime" format="HH:mm" value-format="HH:mm" :picker-options="{selectableRange:`00:00:00 - 23:59:00`}"
						 :placeholder="$t('input_65')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 155px">
							<el-checkbox v-model="beginChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_585')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.endTime" format="HH:mm" value-format="HH:mm" :picker-options="{selectableRange:`00:00:00 - 23:59:00`}"
						 :placeholder="$t('input_65')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 105px">
							<el-checkbox v-model="endChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="timeAddSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_15')" :visible.sync="dialogSpotTimeEdit" append-to-body :close-on-click-modal='false' width="450px"
		 top="15%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p>{{$t('label_580')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.beginTime" format="HH:mm" value-format="HH:mm" :picker-options="{selectableRange:`00:00:00 - 23:59:00`}"
						 :placeholder="$t('input_65')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 155px">
							<el-checkbox v-model="beginChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_585')}}</p>
					<div class="mesInput">
						<el-time-picker v-model="tableDataTreeTimeEdit.endTime" format="HH:mm" value-format="HH:mm" :picker-options="{selectableRange:`00:00:00 - 23:59:00`}"
						 :placeholder="$t('input_65')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 105px">
							<el-checkbox v-model="endChecked"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="timeUpdateSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_65')" :visible.sync="dialogSpotBatchTimeEdit" append-to-body :close-on-click-modal='false' width="450px"
		 top="15%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p>{{$t('label_580')}}</p>
					<div class="mesInput">
						<!-- <el-time-picker
              style="width: 210px"
              v-model="tableDataTreeBatchTimeEdit.beginTime"
			  format="HH:mm:ss" value-format="HH:mm:ss"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
              placeholder="请选择时间">
            </el-time-picker> -->
						<el-time-picker style="width: 210px" v-model="tableDataTreeBatchTimeEdit.beginTime" format="HH:mm" value-format="HH:mm"
						 :picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_65')">
						</el-time-picker>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_585')}}</p>
					<div class="mesInput">
						<!-- <el-time-picker
              style="width: 210px"
              v-model="tableDataTreeBatchTimeEdit.endTime"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
              placeholder="请选择时间">
            </el-time-picker> -->
						<el-time-picker style="width: 210px" v-model="tableDataTreeBatchTimeEdit.endTime" format="HH:mm" value-format="HH:mm"
						 :picker-options="{selectableRange:`00:00:00 - 23:59:00`}" :placeholder="$t('input_65')">
						</el-time-picker>
						<span style="position:absolute;right: 35px;bottom: 205px">
							<el-checkbox v-model="endChecked2"></el-checkbox>{{$t('label_151')}}
						</span>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_830')}}</p>
					<div class="mesInput">
						<el-input v-model="tableDataTreeBatchTimeEdit.duration"></el-input>
						<span style="position:absolute;right: 110px;bottom: 155px">{{$t('label_647')}}</span>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_831')}}</p>
					<div class="mesInput">
						<el-input v-model="tableDataTreeBatchTimeEdit.intervalDuration"></el-input>
						<span style="position:absolute;right: 110px;bottom: 105px">{{$t('label_647')}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="timeBatchSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>
    <select-tree
      :showFlag="selectTreeShowFlag" :typeFlag="selectTreeTypeFlag" :treeNodes="treeNodes"
      @selectTreeCloseHandle="selectTreeShowFlag = false" @getSelectedList="getSelectedList"></select-tree>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
  import calendar from "@/components/list/calendar/calendar";
	import checkItemParam from "@/components/list/displayPage/checkItemParam";
	import checkItem from "@/components/list/displayPage/checkPlan";
	import checkItemArea from "@/components/list/displayPage/checkItemArea";
	import tree from "@/components/list/tree/checkTree.vue";
  import selectTree from "@/components/list/tree/selectTree.vue";
	import file from "@/assets/js/file/file.js";
	import spotCheck from "@/assets/js/spotCheck/spotCheck.js";

	export default {
		name: 'spotCheckPage',
		components: {
			Page,
			tree,
			calendar,
			checkItem,
			checkItemParam,
			checkItemArea,
      selectTree
		},
		data() {
			return {
				currentSelectedYear: '', // 新增：存储选中的年份（全局可用）
        saveLoading: false,
				treeShow: true,
				checkStatus: "0",
				checkStatusBtn: 0,
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				pageNumTime: 1,
				pageSizeTime: 10,
				pageCountTime: 0,
				Readytime: '',
				getTreeMes: '0',
				beginChecked: false,
				endChecked: false,
				endChecked2: false,
				dialogDeviceSpot: false,
				dialogSpotTimeAdd: false,
				dialogSpotTimeEdit: false,
				dialogSpotTimeDelete: false,
				dialogSpotBatchTimeEdit: false,
				calendarData: [],
				MenuRoleList: [],
				tableDataTreeEdit: {
					spotPro: '漏油渗油',
					spotCycle: '0',
					spotFun: '目视',
					judge: '干净',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					weekend: '0',
					month: '每月初',
					monthD: '1',
					monthDMes: '1',
				},
				tableDataTreeTimeEdit: {
					id: '',
					deviceId: '',
					beginTime: '',
					endTime: '',
					beginTimeOverDay: '',
					endTimeOverDay: ''
				},
				tableDataTreeBatchTimeEdit: {
					deviceId: '',
					type: '',
					beginTime: '',
					endTime: '',
					overDay: '',
					duration: '',
					intervalDuration: ''
				},
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2',
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3',
				},
				checkCount: {
					checkStatus0: '',
					checkStatus1: '',
					checkStatus2: '',
					checkStatus3: '',
					num: '',
					numInfoAll: '',
					numTypeCheckInfoAll: ''
				},
				checkPlanCount: {
					checknum: '',
					durationnum: '',
					num: '',
				},
				tableDataTreeInfo: {},
				tableDataTreeTimeInfo: {},
				treeFlag: false,
				checkName: '',
				startORstopList: {
					id: '',
					pid: '',
					type: '',
					change: '',
					time: '',
					planFrom: ''
				},
				calendarList: {
					id: '',
					type: '',
					year: ''
				},
				selectTimeDataList: {
					pidType: 0,
					type: '',
					id: '',
				},
				dataDevice: [{
					label: this.$t('label_272'),
					children: [{
						label: '放电加工机',
						id: 1,
						children: [{
							label: 'EA6',
							sta: '0',
							level: '2',
						}, {
							label: 'EA8',
							sta: '1',
							level: '2',
						}, {
							label: 'EA8A',
							sta: '2',
							level: '2',
						}, {
							label: 'EA8B',
							sta: '3',
							level: '2',
						}, ]
					}, {
						label: '三次元测量仪',
					}]
				}],
				dataArea: [{
					label: this.$t('label_272'),
					children: [{
						label: '机电部',
						children: [{
							label: '车间1',
							id: 1,
							children: [{
								label: '产线1',
								sta: '0',
							}, {
								label: '产线2',
								sta: '1',
							}, {
								label: '产线3',
								sta: '2',
							}, {
								label: '产线4',
								sta: '3',
							}, ]
						}, {
							label: '车间2',
						}, {
							label: '车间3',
						}, {
							label: '车间4',
						}, ]
					}]
				}],
				spotFunOptions: [{
					value: '0',
					label: '目视'
				}],
				weekendMesOptions: [{
					value: '0',
					label: this.$t('label_719')
				}, {
					value: '1',
					label: this.$t('label_721')
				}, {
					value: '2',
					label: this.$t('label_723')
				}, {
					value: '3',
					label: this.$t('label_725')
				}, {
					value: '4',
					label: this.$t('label_728')
				}, {
					value: '5',
					label: this.$t('label_730')
				}, {
					value: '6',
					label: this.$t('label_716')
				}, ],
				monthDOptions: [],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				statusNumList: [{
					text: '设备类型数量',
					color: '#0353c1',
					num: '7'
				}, {
					text: '计划启用数量',
					color: '#3fb393',
					num: '1'
				}, {
					text: '计划未启用数量',
					color: '#ffb400',
					num: '1'
				}, {
					text: '计划停用数量',
					color: '#fe0000',
					num: '1'
				}, {
					text: '无计划数量',
					color: '#aeaeae',
					num: '4'
				}],
				allTableData: [],
				allAreaData: [],
				allDeviceData: [{
					name: '放电加工机 EA6 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '0',
					sort: '0',
				}, {
					name: '切割机 FA8 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '1',
					sort: '1',
				}, {
					name: '放电加工机 EA6 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '0',
					sort: '0',
				}, {
					name: '切割机 FA8 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '1',
					sort: '1',
				}, {
					name: '放电加工机 EA6 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '0',
					sort: '0',
				}, {
					name: '切割机 FA8 YFHEGHO003',
					runStatus: '正常',
					spotTime: '10',
					spotNum: '10',
					spotNumStatus: '1',
					sort: '1',
				}],
				tableDataTree: [{
					spotPro: '漏油渗油 ',
					spotCycle: '每天',
					spotFun: '目视',
					judge: '干净',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					sort: '1'
				}, {
					spotPro: '煤油量 ',
					spotCycle: '每周一',
					spotFun: '目视',
					judge: '干净',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					sort: '1'
				}, {
					spotPro: '漏油渗油 ',
					spotCycle: '每天',
					spotFun: '目视',
					judge: '干净',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					sort: '1'
				}, {
					spotPro: '煤油量 ',
					spotCycle: '每周一',
					spotFun: '目视',
					judge: '干净',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					sort: '1'
				}, {
					spotPro: '漏油渗油 ',
					spotCycle: '每天',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					spotFun: '目视',
					judge: '干净',
					sort: '1'
				}, {
					spotPro: '煤油量 ',
					spotCycle: '每周一',
					spotFun: '目视',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					judge: '干净',
					sort: '1'
				}, {
					spotPro: '漏油渗油',
					spotCycle: '每周一',
					spotFun: '目视',
					selectOption: '0',
					spotProCon: '查看设备周围是否有漏油痕迹',
					photoStyle: '0',
					judge: '干净',
					sort: '1'
				}],
				tableDataTreeTime: [],
				statusText: [{
						id: '0',
						text: this.$t('label_447'),
						color: '#000000'
					},
					{
						id: '1',
						text: this.$t('label_443'),
						color: '#ffb400'
					},
					{
						id: '2',
						text: this.$t('btn_36'),
						color: '#3fb393'
					},
					{
						id: '3',
						text: this.$t('btn_37'),
						color: '#fe0000'
					},
				],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				activeNameDevice: 'device',
				pickerOptions: {
					disabledDate(date) {
						// //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
						// return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
						  // 允许所有日期
                        return false;
					}
				},
				usingStart: true,
				changeStart:false,
				width: '340px',
				qrCodeShow: false,
        treeNodes: [],
        selectTreeShowFlag: false,
        selectTreeTypeFlag: 0, // 0: 区域 | 1: 设备类型
        selectedList: [],
        buttonType: 0 ,// 0: 重置计划状态 | 1: 不作业
		saveLoading: false
			}
		},
		methods: {
			dbSelected(row) {
				if (this.getTreeMes == '0') { //类型
					this.$refs.tree0.dbSelected(row.id, null);
				} else { //区域
					this.$refs.tree1.dbSelected(row.id, null);
				}
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndexTime(index) {
				return (this.pageNumTime - 1) * this.pageSizeTime + index + 1
			},
			handler() {

			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogSpotTimeAdd = false;
				this.dialogSpotTimeEdit = false;
				this.dialogSpotBatchTimeEdit = false;
			},
			moveUp(item, index) {
				this.tableDataTree.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
				this.tableDataTree.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
			},
			// 下移
			moveDown(item, index) {
				this.tableDataTree.splice(index + 2, 0, item);
				this.tableDataTree.splice(index, 1);
			},
			moveUpDevice(item, index) {
				this.allDeviceData.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
				this.allDeviceData.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
			},
			// 下移
			moveDownDevice(item, index) {
				this.allDeviceData.splice(index + 2, 0, item);
				this.allDeviceData.splice(index, 1);
			},
			// 控制下移按钮的显示于隐藏
			getFormLength(index) {
				if (index === this.tableDataTree.length - 1) return true;
				else return false;
			},
			getFormLengthDevice(index) {
				if (index === this.allDeviceData.length - 1) return true;
				else return false;
			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeDevice(info) {},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {
				this.tableDataTreeTimeInfo = info;
			},
			handleNodeClickDevice(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '0';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleNodeClickArea(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '2';
				} else {
					this.getTreeMes = '3';
				}
			},
			handleClickTree(tab, event) {
				if (tab.label == this.$t('label_433')) {
					this.treeFlag = false;
					this.searchDataList = {
						level: 0
					}
					this.selectEquipmentCheckPlanCount({
						level: '1',
						id: ''
					});
					this.search();
					this.getTreeMes = '2';
					this.selectTimeDataList.pidType = 2;
				} else {
					this.treeFlag = true;
					this.search();
					this.getTreeMes = '0';
					this.selectTimeDataList.pidType = 0;
				}
			},
			handleClickSpot(tab, event) {
				// console.log(tab, event);
			},
			handleClickDevice(tab, event) {
				console.log(tab, event);
			},
			searchPage(param) {
				let dataParam = this.searchDataList;
				let newParam = Object.assign(param, dataParam);
				this.tableParamDataPageNum = newParam.pageNum;
				this.tableParamDataPageSize = newParam.pageSize;
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
				if (!this.treeFlag) {
					this.selectEquipmentAreaPageAll(param);
				} else {
					this.selectEquipmentCheckPageAll(param);
				}
			},
			getDeviceMes(data) {
				this.tableDataTreeTimeInfo = {};
				this.usingStart = true;
				this.checkStatus = data.checkStatus;
				if (data.checkStatus == "1" || data.checkStatus == "2") {
					this.checkStatusBtn = 0;
					this.startORstopList.time = data.ctime;
				} else {
					this.checkStatusBtn = 1;
					this.startORstopList.time = this.getNowTime();
				}
				this.checkName = data.name;
				if (data.name == this.$t('label_272')) {
					if (!this.treeFlag) {
						this.getTreeMes = '2';
						this.searchDataList = {
							level: 0
						}
						this.selectEquipmentCheckPlanCount({
							level: '1',
							id: ''
						})
					} else {
						this.getTreeMes = '0';
					}
					this.search();
				} else {
					let param = {
						pageNum: 1,
						pageSize: this.pageSize,
					}
					this.deviceDetailMes = data;
					this.tableDataTreeTimeEdit.deviceId = data.id;
					this.tableDataTreeTimeEdit.type = data.type;
					this.tableDataTreeBatchTimeEdit.deviceId = data.id;
					this.tableDataTreeBatchTimeEdit.type = data.type;
					this.startORstopList.id = data.id;
					this.startORstopList.pid = data.pid;
					this.startORstopList.type = data.type;
					this.startORstopList.planFrom = data.type;
					this.selectTimeDataList.id = data.id;
					this.selectTimeDataList.type = data.type;
					this.selectTimeData();
					data.type = data.type.toString()
					if (data.type == '1') {
						this.getTreeMes = '3';
						this.$nextTick(() => {
							this.$refs.checkItemParamDisplay.newMes(data.id, 1);
							this.$refs.checkItemParamDisplay.searchPage(param);
							setInterval(() => {
								if (this.$refs.checkItemParamDisplay.pageCount == 0) {
									this.usingStart = false
								}else{
									this.usingStart = true
								}
							}, 30000)
							this.calendarList.id = data.id;
							this.calendarList.type = data.type;
							this.calendarList.year = this.$refs.calendarDisplay.year;
							this.selectRestList();
						})
					} else if (data.type == '2') {
						this.searchDataList = {
							level: 1,
							id: data.id
						}
						this.getTreeMes = '1';
            file.getOrgTreeNodeByOrgId({orgId: data.id}).then((res) => {
              this.treeNodes = res.data.data;
              console.log("orgtree", this.treeNodes);
            });
						this.$nextTick(() => {
							this.$refs.checkItemAreaDisplay.newMes(data.id, 1);
							this.$refs.checkItemAreaDisplay.searchPage(param);
							setInterval(() => {
								if (this.$refs.checkItemAreaDisplay.pageCount == 0) {
									this.usingStart = false
								}else{
									this.usingStart = true
								}
							}, 30000)
							this.calendarList.id = data.id;
							this.calendarList.type = data.type;
							this.calendarList.year = this.$refs.calendarDisplay.year;
							this.selectRestList();
						})
						this.searchDataList = {
							areaId: data.id,
							level: 1,
							id: data.id
						}
						this.search();
						this.selectEquipmentCheckPlanCount({
							level: '2',
							id: data.id
						})
					} else if (data.type == '0') {
						this.getTreeMes = '3';
            file.getTypeTreeNodeByTypeId({typeId: data.id}).then((res) => {
              this.treeNodes = res.data.data;
              console.log("typetree", this.treeNodes);
            });
						this.$nextTick(() => {
							this.$refs.checkItemDisplay.newMes(data.id);
							this.$refs.checkItemDisplay.searchPage(param);
							setInterval(() => {
								if (this.$refs.checkItemDisplay.pageCount == 0) {
									this.usingStart = false
								}else{
									this.usingStart = true
								}
							}, 30000)
							this.calendarList.id = data.id;
							this.calendarList.type = data.type;
							this.calendarList.year = this.$refs.calendarDisplay.year;
							this.selectRestList();
						})
						this.searchDataList = {
							deviceId: data.id
						}
						this.search();
					}

				}
			},
			changeSelectMonth() {
				this.tableDataTreeEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
					}
				}
			},
			selectEquipmentCheckPageAll(param) {
				file.selectEquipmentCheckPageAll(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.allTableData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectEquipmentAreaPageAll(param) {
				let dataParam = this.searchDataList;
				let newParam = Object.assign(param, dataParam);
				file.selectEquipmentAreaPageAll(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.allAreaData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModelArea'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectEquipmentCheckCount() {
				file.selectEquipmentCheckCount().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkCount = data.data[0];
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectEquipmentCheckPlanCount(param) {
				file.selectEquipmentCheckPlanCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						// this.checkCount = data.data[0];
						this.checkPlanCount = data.data
						if(data.data==null){
							this.checkPlanCount ={
					checknum: 0,
					durationnum: 0,
					num: 0,
				}
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			timeAdd() {
				if (this.checkStatusBtn == 0) {
					this.$message({
						message: this.$t('msg_73'),
						type: 'error'
					});
					return;
				}
				this.beginChecked = false;
				this.endChecked = false;
				this.tableDataTreeTimeEdit.beginTime = '';
				this.tableDataTreeTimeEdit.endTime = '';
				this.dialogSpotTimeAdd = true;
			},
			timeUpdate() {
				if (this.checkStatusBtn == 0) {
					this.$message({
						message: this.$t('msg_73'),
						type: 'error'
					});
					return;
				}
				if (this.tableDataTreeTimeInfo != null && Object.keys(this.tableDataTreeTimeInfo).length > 0) {
					if (this.tableDataTreeTimeInfo.beginTimeOverDay == 0) {
						this.beginChecked = false;
					} else {
						this.beginChecked = true;
					}
					if (this.tableDataTreeTimeInfo.endTimeOverDay == 0) {
						this.endChecked = false;
					} else {
						this.endChecked = true;
					}
					this.tableDataTreeTimeEdit.beginTime = this.tableDataTreeTimeInfo.beginTime;
					this.tableDataTreeTimeEdit.endTime = this.tableDataTreeTimeInfo.endTime;
					this.tableDataTreeTimeEdit.id = this.tableDataTreeTimeInfo.id;
					this.dialogSpotTimeEdit = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			timeDelete() {
				if (this.checkStatusBtn == 0) {
					this.$message({
						message: this.$t('msg_73'),
						type: 'error'
					});
					return;
				}
				let param = this.tableDataTreeTimeInfo.id;
				if (Object.keys(this.tableDataTreeTimeInfo).length > 0) {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						spotCheck.checkTimeDelete(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.selectTimeData();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			timeBatch() {
				if (this.checkStatusBtn == 0) {
					this.$message({
						message: this.$t('msg_73'),
						type: 'error'
					});
					return;
				}
				this.endChecked2 = false;
				this.tableDataTreeBatchTimeEdit.beginTime = '';
				this.tableDataTreeBatchTimeEdit.endTime = '';
				this.tableDataTreeBatchTimeEdit.duration = '';
				this.tableDataTreeBatchTimeEdit.intervalDuration = '';
				this.dialogSpotBatchTimeEdit = true;
			},
			timeAddSave() {
        this.saveLoading = true;
				if (this.beginChecked) {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 0;
				}
				if (this.endChecked) {
					this.tableDataTreeTimeEdit.endTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.endTimeOverDay = 0;
				}
				spotCheck.checkTimeAdd(this.tableDataTreeTimeEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectTimeData();
						this.dialogSpotTimeAdd = false;
					} else {
					  this.$message.error(data.message)
          }
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			timeUpdateSave() {
        this.saveLoading = true;
				if (this.beginChecked) {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.beginTimeOverDay = 0;
				}
				if (this.endChecked) {
					this.tableDataTreeTimeEdit.endTimeOverDay = 1;
				} else {
					this.tableDataTreeTimeEdit.endTimeOverDay = 0;
				}
				spotCheck.checkTimeUpdate(this.tableDataTreeTimeEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectTimeData();
						this.dialogSpotTimeEdit = false;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			timeBatchSave() {
                this.saveLoading = true;
				if (this.endChecked2) {
					this.tableDataTreeBatchTimeEdit.overDay = 1;
				} else {
					this.tableDataTreeBatchTimeEdit.overDay = 0;
				}
				spotCheck.timeBatchSave(this.tableDataTreeBatchTimeEdit).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectTimeData();
						this.dialogSpotBatchTimeEdit = false;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			timeAcquiescence() {
				this.saveLoading = true;
				if (this.checkStatusBtn == 0) {
					this.$message({
						message: this.$t('msg_73'),
						type: 'error'
					});
					return;
				}
				spotCheck.timeAcquiescence(this.selectTimeDataList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_24'),
							type: 'success'
						});
					} else {
						this.$message({
							message: data.message,
							type: 'error'
						});
					}
					this.selectTimeData();
					this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
					this.saveLoading = false;
				})
			},
			selectTimeData() {
				let param = {
					pageNum: this.pageNumTime,
					pageSize: this.pageSizeTime,
					type: this.tableDataTreeTimeEdit.type,
					deviceId: this.tableDataTreeTimeEdit.deviceId
				}
				spotCheck.selectTimeData(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records;
						this.pageSizeTime = data.data.size;
						this.pageCountTime = data.data.total;
						this.pageNumTime = data.data.current;
						this.$refs['pageModelTime'].setCurrent(this.pageNumTime);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectTime(page) {
				let param = {
					type: this.tableDataTreeTimeEdit.type,
					deviceId: this.tableDataTreeTimeEdit.deviceId
				}
				let newParam = Object.assign(page, param);
				spotCheck.selectTimeData(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records;
						this.pageSizeTime = data.data.size;
						this.pageCountTime = data.data.total;
						this.pageNumTime = data.data.current;
						this.$refs['pageModelTime'].setCurrent(this.pageNumTime);
					}
				}).catch((response) => {
					console.log(response)
				})
			},

			startORstop(change) {
				if (change == 0 && !this.usingStart) {
					utils.messageAlert(this.$t('msg_74'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				if (change == 0 && this.pageCountTime <= 0) {
					utils.messageAlert(this.$t('msg_75'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				if(this.changeStart){
					if (change == 0 && this.activeNameTree=='second') {
					let listTime = this.$refs.checkItemAreaDisplay.tableData;
					for (let i = 0; i < listTime.length; i++) {
						if (listTime[i].duration == "" || listTime[i].duration == null || listTime[i].duration == 0) {
							utils.messageAlert(this.$t('msg_76'), this.$t('label_358'), this.$t('label_100'));
							return false
							break
						}
					}
					}
				}
				let olCheckStatusBtn = this.checkStatusBtn
				this.checkStatusBtn = change;
				// debugger
				this.startORstopList.change = change;
				if (this.startORstopList.time.indexOf(" 00:00:00") == -1) {
					this.startORstopList.time = this.startORstopList.time + " 00:00:00";
				}
				let name = this.$t('btn_36');
				if (change == 1) {
					name = this.$t('btn_37');
					this.startORstopList.time = '';
				}
				file.selectEquipmentCheckStartORstop(this.startORstopList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: name + this.$t('msg_23'),
							type: 'success'
						});
						this.treeShow = false;
						// this.$nextTick(() => {})
						this.$nextTick(() => {
							this.treeShow = true;
							this.$nextTick(() => {
								let eqId = this.calendarList.type != 1 ? null : this.startORstopList.id;
								let id = this.calendarList.type != 1 ? this.startORstopList.id : this.startORstopList.pid;
								if (this.getTreeMes == '0') { //类型
									this.$refs.tree0.dbSelected(id, eqId);
								} else { //区域
									this.$refs.tree1.dbSelected(id, eqId);
								}
							})
						})
					} else {
						this.checkStatusBtn = olCheckStatusBtn
						this.$message({
							message: name + this.$t('msg_77'),
							type: 'error'
						});
					}
				}).catch((response) => {
					this.checkStatusBtn = olCheckStatusBtn
					console.log(response)
					this.$message({
						message: name + this.$t('msg_77'),
						type: 'error'
					});
				})
			},
			saveRest(param) {
				this.saveLoading = true
				let dataParam = {
					id: this.tableDataTreeTimeEdit.deviceId,
					type: this.tableDataTreeTimeEdit.type
				}
				let newParam = Object.assign(param, dataParam);
				file.saveMaintainRest(newParam).then((response) => {
					const data = response.data;
					this.saveLoading = false
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_21'),
							type: 'success'
						});
						this.selectRest(param);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			acquiescenceRest(param) {
                this.saveLoading = true
				let dataParam = {
					id: this.selectTimeDataList.id,
					type: this.selectTimeDataList.type,
					pidType: this.selectTimeDataList.pidType,
				}
				let newParam = Object.assign(param, dataParam);
				file.saveAcquiescenceRest(newParam).then((response) => {
					const data = response.data;
					this.saveLoading = false
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_24'),
							type: 'success'
						});
						this.selectRestList();
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectRest(param) {
				let dataParam = {
					id: this.startORstopList.id,
					type: this.startORstopList.type
				}
				let newParam = Object.assign(param, dataParam);
				file.selectRest(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectRestList() {
				this.calendarData = [];
				file.selectRest(this.calendarList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
      resetHandle() {
        this.buttonType = 0;
        switch (this.tableDataTreeTimeEdit.type) {
          case '0' : {
            this.selectTreeTypeFlag = 1;
            this.selectTreeShowFlag = true;
            break;
          }
          case 1 : 
		  	console.log(this.tableDataTreeTimeEdit.type)
		  	this.resetEqPlanStatus(this.tableDataTreeTimeEdit.deviceId); 
		  	break;
          case '2' : {
            this.selectTreeTypeFlag = 0;
            this.selectTreeShowFlag = true;
            break;
          }
        }
      },
      resetEqPlanStatus(eqId) {
			  let eqIds = [];
			  eqIds.push(eqId);
        this.resetPlanStatus(eqIds);
      },
      resetPlanStatus(eqIds) {
        this.$confirm(this.$t('msg_232') + '?', this.$t('label_358'), {
          confirmButtonText: this.$t('btn_20'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          file.resetPlanStatus({equipmentIds: eqIds}).then((res) => {
            if (res.data.code == 1) {
              this.$message.success(this.$t('msg_23'));
              this.checkStatus = 0;
              this.treeShow = false;
              // this.$nextTick(() => {})
              this.$nextTick(() => {
                this.treeShow = true;
                this.$nextTick(() => {
                  let eqId = this.calendarList.type != 1 ? null : this.startORstopList.id;
                  let id = this.calendarList.type != 1 ? this.startORstopList.id : this.startORstopList.pid;
                  if (this.getTreeMes == '0') { //类型
                    this.$refs.tree0.dbSelected(id, eqId);
                  } else { //区域
                    this.$refs.tree1.dbSelected(id, eqId);
                  }
                })
              })
            }
          }).catch((e) => {
            console.log(e);
          })
        }).catch(() => {
        })
      },
      notWorkHandle() {
        this.buttonType = 1;
        console.log(this.tableDataTreeTimeEdit.type)
        switch (this.tableDataTreeTimeEdit.type) {
          case '0' : {
            this.selectTreeTypeFlag = 1;
            this.selectTreeShowFlag = true;
            break;
          }
          case '1' : this.notWork(this.tableDataTreeTimeEdit.deviceId); break;
          case '2' : {
            this.selectTreeTypeFlag = 0;
            this.selectTreeShowFlag = true;
            break;
          }
        }
        console.log(this.selectTreeTypeFlag, this.selectTreeShowFlag)
      },
	  syncReginoalRest(){
		if(!Array.isArray(this.calendarData) || this.calendarData.length === 0){
			this.$message.warning(this.$t('msg_256'));
			return; 
		}
		console.log(this.calendarData[0].year)
		this.selectRest({
			year: this.calendarData[0].year
		});

		let dataParam = {
			id: this.startORstopList.id,
			type: this.startORstopList.type,
			year: this.calendarData[0].year 
		}
		// let newParam = Object.assign(this.newSyncParam,dataParam);
		file.syncReginoalRest(dataParam).then((response) => {
			const data = response.data;
			if(data.code == "1"){
				this.calendarData = data.data;
			} 
		}).catch((response)=> {
			console.log(response)
			
		})
	  },
      notWork(eqId) {
        let ids = [];
        ids.push(eqId);
        this.$confirm(this.$t('msg_93'), this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          spotCheck.notWork(ids).then((res) => {
            if (res.code == 1) {
              this.$message.success(this.$t('msg_24'));
            }
          });
        }).catch(() => {

        })
      },
      selectTreeCloseHandle() {
        this.selectTreeShowFlag = false;
      },
      getSelectedList(data) {
        // console.log("selectedList", data);
        this.selectedList = data;
        if (this.buttonType == 0) {
          if (this.selectTreeTypeFlag == 0) {
            this.$confirm(this.$t('msg_233') + '?', this.$t('label_358'), {
              confirmButtonText: this.$t('label_100'),
              cancelButtonText: this.$t('btn_1'),
              type: 'warning'
            }).then(() => {
              file.resetOrgPlanStatus(data).then((res) => {
                if (res.data.code == 1) {
                  this.$message.success(this.$t('msg_24'));
                  this.checkStatus = 0;
                  this.treeShow = false;
                  // this.$nextTick(() => {})
                  this.$nextTick(() => {
                    this.treeShow = true;
                    this.$nextTick(() => {
                      let eqId = this.calendarList.type != 1 ? null : this.startORstopList.id;
                      let id = this.calendarList.type != 1 ? this.startORstopList.id : this.startORstopList.pid;
                      if (this.getTreeMes == '0') { //类型
                        this.$refs.tree0.dbSelected(id, eqId);
                      } else { //区域
                        this.$refs.tree1.dbSelected(id, eqId);
                      }
                    })
                  })
                }
              }).catch((e) => {
                console.log(e);
              });
            });
          } else {
            this.$confirm(this.$t('msg_234') + '?', this.$t('label_358'), {
              confirmButtonText: this.$t('label_100'),
              cancelButtonText: this.$t('btn_1'),
              type: 'warning'
            }).then(() => {
              file.resetTypePlanStatus(data).then((res) => {
                if (res.data.code == 1) {
                  this.$message.success(this.$t('msg_24'));
                  this.checkStatus = 0;
                  this.treeShow = false;
                  // this.$nextTick(() => {})
                  this.$nextTick(() => {
                    this.treeShow = true;
                    this.$nextTick(() => {
                      let eqId = this.calendarList.type != 1 ? null : this.startORstopList.id;
                      let id = this.calendarList.type != 1 ? this.startORstopList.id : this.startORstopList.pid;
                      if (this.getTreeMes == '0') { //类型
                        this.$refs.tree0.dbSelected(id, eqId);
                      } else { //区域
                        this.$refs.tree1.dbSelected(id, eqId);
                      }
                    })
                  })
                }
              }).catch((e) => {
                console.log(e);
              });
            });
          }
        } else {
          let eqIds = []
          data.forEach(item => {
            if (item.type == 2) {
              eqIds.push(item.id);
            }
          });
          this.$confirm(this.$t('msg_235') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning'
          }).then(() => {
            spotCheck.notWork(eqIds).then((res) => {
              if (res.code == 1) {
                this.$message.success(this.$t('msg_24'));
              }
            }).catch((e) => {
              console.log(e);
            })
          }).catch(() => {
            // this.selectedList = [];
          });
        }
      }
		},
		created() {
			// this.startORstopList.time = this.getNowTime();
			this.MenuRoleList = this.$store.getters.getMenu;
			this.selectEquipmentCheckCount();
			window.selectEquipmentCheckPlanCount = this.selectEquipmentCheckPlanCount;
			this.selectTimeDataList.pidType=2;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
		},
	}
</script>

<style>
	.treeMes .spotMesBox.gaobugou {
		height: calc(100% - 115px);
	}
	.el-table__body tr.current-row>td {
	    background-color: #9acefe !important ;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/spotCheck/spotCheckPage.vue